import { SagaIterator } from 'redux-saga'
import { put, takeLatest, call } from 'redux-saga/effects'
import {
  getAllPermissions,
  hideLoader,
  showLoader,
  updateAllPermissionState,
} from '../slices'
import { PayloadAction } from '@reduxjs/toolkit'
import { TableFilterApiBody } from '../types'
import { getPermissionsList } from '../apis'

function* fetchAllPermissions(
  action: PayloadAction<TableFilterApiBody>
): SagaIterator {
  try {
    yield put(showLoader())
    const response = yield call(getPermissionsList, action.payload)
    if (response?.data?.content) {
      yield put(
        updateAllPermissionState({
          permissions: response.data.content,
        })
      )
    }
  } catch (err) {
    console.log(err)
  } finally {
    yield put(hideLoader())
  }
}

export function* watchFetchAllPermissions() {
  yield takeLatest(getAllPermissions.type, fetchAllPermissions)
}
